import { areConsentsAccepted, enableScriptForConsents, loadScipt, sendWhenReady } from "layouts/js/scriptsManager"

	
const isMobileApp = location.href.includes('nb_mobile_app=1')

function showOCMInRead() {
	window?.OCM?.nbInread()
}

const vidAdsMapping = [{
	id: 241,
	group: [2, 3, 9, 23, 18],
}, {
	id: 909,
	group: [7, 8, 4, 15, 17, 53],
}, {
	id: 908,
	group: [11, 12, 14, 19, 20, 10, 28, 63],
}];


//inline ads
//deprecated
if (window.cmpData) {
	post3rdPartyScripts(window.cmpData);
} else {
	window.addEventListener('cmpChanged', post3rdPartyScripts);
}


// document.addEventListener( "astro:page-load", () => {
// 	window.addEventListener('cmpChanged', post3rdPartyScripts);

// 	const tempScriptsEnabled = location.href.indexOf("thebutterfly") != -1;
// 	tempScriptsEnabled && window.addEventListener('cmpChanged', (e) => {
// 		enableScriptForConsents('thebutterfly');
// 	});

// });

//deprecated
// document.addEventListener( "astro:before-preparation", () => {
// 	window.removeEventListener('cmpChanged', post3rdPartyScripts);
// 	window.removeEventListener('nbInreadReady', showOCMInRead );
	
// 	if (window["VidadsParser_loaded"])
// 		delete window["VidadsParser_loaded"];
// });


function post3rdPartyScripts(e) { 	
	const purposes = e?.detail ?? {};

	const $article = document.getElementById("articleBody");
	
	if (!$article)
		return;

	const hideAds = $article.getAttribute('data-hideads') == "1";
	const mainCategoryID = $article.getAttribute('data-maincategoryid');
	const articleType = $article.getAttribute('data-articletype');
	const articleID = $article.getAttribute('data-id');

	//exitbee
	if (!hideAds && areConsentsAccepted(purposes, [1,2,7,9,10]) /* && window.innerWidth <= 768 */ && !isMobileApp) {
		(function (e, x, i, t, b) {
			e["ExitBeeObject"] = b; e[b] = e[b] ||
			function () { (e[b].args = e[b].args || []).push(arguments); };
			const a = x.createElement(i), m = x.getElementsByTagName(i)[0];
			a.async = 1; a.src = t; m.parentNode.insertBefore(a, m)
		})(window, document, "script", "https://cdn.exitbee.com/xtb.min.js", "xtb");
		window["xtb"]("loadSite", "7232");
	}

	//vidads
	if (!hideAds && areConsentsAccepted(purposes, [1,2,7,9,10]) && !isMobileApp && articleID!='11852539') {
		
		window["VidadsParser_loaded"] = () => {
			const filteredMap = vidAdsMapping.filter((I) => {
				return I.group.includes(Number(mainCategoryID));
			});
			
			let vidAdsCategoryID = filteredMap.length > 0 ? filteredMap[0].id : null;
			if (articleType == 'Advertorial')
				vidAdsCategoryID = 1;

			if (vidAdsCategoryID) {
				
				new VidadsVideo.Parser({
					youtube_image_filename: "hqdefault.jpg",
					vastUrl: `https://www.vidads.gr/get/video/vast3/${vidAdsCategoryID}`,
					fluid: true,
					beforeReplace: (el) => {
						if (el.getAttribute("data-src"))
							el.setAttribute("src", el.getAttribute('data-src'));
	
						return true;
					},
				});					
			}
		}

		loadScipt( 'https://www.vidads.gr/scripts/parser.min.js' );
	}

	//phaistos
	if (!hideAds && areConsentsAccepted(purposes, [1,2,7,9,10]) && !isMobileApp) {
		enableScriptForConsents('phaistos');
	}

	//taboola
	if (!hideAds && areConsentsAccepted(purposes, []) && !isMobileApp) {
		enableScriptForConsents('agora');
	}

	if (!hideAds && !isMobileApp) {
		if (window?.OCM?.nbInread)
			window.OCM.nbInread();
		else 
			window.addEventListener('nbInreadReady', showOCMInRead );
	}
}